import { render, staticRenderFns } from "./FactHealthPlan.vue?vue&type=template&id=0a6abfdd&scoped=true&"
import script from "./FactHealthPlan.vue?vue&type=script&lang=js&"
export * from "./FactHealthPlan.vue?vue&type=script&lang=js&"
import style0 from "./FactHealthPlan.vue?vue&type=style&index=0&id=0a6abfdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6abfdd",
  null
  
)

export default component.exports